<template>
    <div>
		<div class="md-layout">
			<div class="md-layout-item md-size-50">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="md-layout">
							<div class="md-layout-item">
								<div class="card-icon">
									<i class="md-icon fas fa-info" />
								</div>
								<h4 class="title">{{ technician.full_name }}</h4>
							</div>
						</div>
					</md-card-header>
					<md-card-content>
						<span class="font-bold">Planning non accessible</span>
					</md-card-content>
				</md-card>
			</div>
		</div>
		<div class="md-layout">
			<div class="md-layout-item md-size-50">
				<md-card class="card-table">
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="md-layout">
							<div class="md-layout-item">
								<div class="card-icon">
									<md-icon>pending_actions</md-icon>
								</div>
								<h4 class="title">Absences permanentes</h4>
							</div>
						</div>
					</md-card-header>
					<md-card-content>
						<md-table v-model="technician.absences.permanents" table-header-color="blue">
							<md-table-row slot="md-table-row" slot-scope="{ item }">
								<md-table-cell md-label="Jour"><span> {{ (item.day_number || item.day_number === 0) ? days[item.day_number] : '-' }}</span></md-table-cell>
								<md-table-cell md-label="Début"><span> {{ $moment(item.date_start).format('DD/MM/YYYY') }}</span></md-table-cell>
								<md-table-cell md-label="Fin"><span> {{ item.date_end ? $moment(item.date_end).format('DD/MM/YYYY') : '-' }}</span></md-table-cell>
								<md-table-cell md-label="" style="min-width: 75px">
									<div class="w-full flex items-center justify-end">
										<div class="mr-2">
											<md-button class="md-icon-button md-raised md-warning"
													   @click="goToRoute('Edit Absence', item.id)">
												<md-icon>edit</md-icon>
											</md-button>
											<md-tooltip md-direction="top">Modifier</md-tooltip>
										</div>
										<div class="mr-2">
											<md-button class="md-icon-button md-raised md-danger"
													   @click="deleteAbsence(item.id)">
												<i class="md-icon fa fa-trash"/>
											</md-button>
											<md-tooltip md-direction="top">Supprimer</md-tooltip>
										</div>
									</div>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</md-card-content>
				</md-card>
			</div>
			<div class="md-layout-item md-size-50">
				<md-card class="card-table">
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="md-layout">
							<div class="md-layout-item">
								<div class="card-icon">
									<md-icon>pending_actions</md-icon>
								</div>
								<h4 class="title">Autres absences</h4>
							</div>
						</div>
					</md-card-header>
					<md-card-content>
						<md-table v-model="technician.absences.others" table-header-color="blue">
							<md-table-row slot="md-table-row" slot-scope="{ item }">
								<md-table-cell md-label="Type d'absence"><span>{{ item.absence_type.name }}</span></md-table-cell>
								<md-table-cell md-label="Début"><span>{{ $moment(item.date_start).format('DD/MM/YYYY' + (item.absence_type_id === 7 ? ' à HH:mm' : '')) }}</span></md-table-cell>
								<md-table-cell md-label="Fin"><span>{{ item.date_end ? $moment(item.date_end).format('DD/MM/YYYY' + (item.absence_type_id === 7 ? ' à HH:mm' : '')) : '-' }}</span></md-table-cell>
								<md-table-cell md-label="" style="min-width: 75px">
									<div class="w-full flex items-center justify-end">
										<div class="mr-2">
											<md-button class="md-icon-button md-raised md-warning"
												@click="goToRoute('Edit Absence', item.id)">
												<md-icon>edit</md-icon>
											</md-button>
											<md-tooltip md-direction="top">Modifier</md-tooltip>
										</div>
										<div class="mr-2">
											<md-button class="md-icon-button md-raised md-danger"
												@click="deleteAbsence(item.id)">
												<i class="md-icon fa fa-trash"/>
											</md-button>
											<md-tooltip md-direction="top">Supprimer</md-tooltip>
										</div>
									</div>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: "TechnicianDetails",
    data() {
        return {
            technician: {
            	absences: {
            		permanents: [],
					others: []
				}
			}
        }
    },
    methods: {
        async getTechnicianDetails() {
            const { data } = await this.$store.dispatch('users/getTechnicianDetails',  { id: this.$route.params.idTechnician })
            this.technician = {
            	...data,
				absences: {
            		permanents: data.absences.filter(absence => { return absence.absence_type_id === 1 }),
            		others: data.absences.filter(absence => { return absence.absence_type_id !== 1 })
				}
			}
        },
		async updateAbsence(id) {
			try {
				await this.$store.dispatch('absences/updateAbsence', { absence_id: id })
				await this.$store.dispatch('alerts/success', 'Absence modifiée')
				await this.getTechnicianDetails()
			} catch (e) {
				await this.$store.dispatch('alerts/error', 'Modification impossible')
			}
		},
		async deleteAbsence(id) {
			try {
				await this.$store.dispatch('absences/deleteAbsence', { absence_id: id })
				await this.$store.dispatch('alerts/success', 'Absence supprimée')
				await this.getTechnicianDetails()
			} catch (e) {
				await this.$store.dispatch('alerts/error', 'Suppression impossible')
			}
		},
		formatWeekdays() {
			let days = []
			this.$moment.weekdays(true).map(day => {
				days.push(day.charAt(0).toUpperCase() + day.slice(1))
			})
			days.pop()
			days.pop()
			this.days = days
		},
		goToRoute(route, id = null) {
			this.$router.push({ name: route, params: { idAbsence: id } })
		}
    },
    mounted() {
        this.getTechnicianDetails()
		this.formatWeekdays()
    }
}
</script>

<style scoped>

</style>
